import { c as _c } from "react/compiler-runtime";
import { Switch, SwitchField } from "../ui/switch";
import { TextMono } from "../ui/text";
import { useThemeStore } from "@/store/theme-store";
import { Description, Label } from "../ui/fieldset";
export const SyncControls = t0 => {
  const $ = _c(16);
  const {
    colorKey
  } = t0;
  let t1;
  if ($[0] !== colorKey) {
    t1 = state => state.sync[state.platform][colorKey];
    $[0] = colorKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sync = useThemeStore(t1);
  const setSync = useThemeStore(_temp);
  let t2;
  if ($[2] !== colorKey || $[3] !== setSync) {
    t2 = checked => {
      setSync(colorKey, checked ? "dark" : "off");
    };
    $[2] = colorKey;
    $[3] = setSync;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onSyncChange = t2;
  let t3;
  if ($[5] !== colorKey) {
    t3 = <Label className="text-muted-foreground text-xs"><TextMono>Sync {colorKey}</TextMono></Label>;
    $[5] = colorKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Description className="text-xs/4 text-pretty sm:text-xs/4">Sync colors between light and dark themes</Description>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <div className="flex flex-col items-start">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = sync === "dark";
  let t7;
  if ($[10] !== onSyncChange || $[11] !== t6) {
    t7 = <Switch checked={t6} onChange={onSyncChange} />;
    $[10] = onSyncChange;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div className="px-2 py-2"><SwitchField className="flex items-center justify-between gap-2">{t5}{t7}</SwitchField></div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(state_0) {
  return state_0.setSync;
}